<template>
  <div class="bg-black px-10">
    <div class="mx-auto flex h-10 w-desktop items-center justify-between">
      <nav class="flex space-x-10 py-2">
        <a
          v-for="item in menuItems"
          :key="item.title"
          :href="item.href"
          :class="[
            item.classList ??
              'text-white hover:text-green-600 focus:text-green-600',
          ]"
          class="text-sm font-bold leading-normal"
        >
          {{ item.title }}
        </a>
      </nav>
      <nav class="flex items-center justify-center space-x-10">
        <LanguageSwitch class="-left-5 top-11 w-72" />
        <a
          class="group flex cursor-pointer items-center text-sm font-bold leading-normal text-white no-underline hover:text-green-600 focus:text-green-600"
          :href="NavigationLib.toCabinet()"
          target="_blank"
        >
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" class="mr-2 h-6 w-6 stroke-current text-white group-hover:text-green-600" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.364 5.636A9 9 0 1 1 5.636 18.364 9 9 0 0 1 18.364 5.636"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.99 8.324a2.813 2.813 0 1 1-3.98 3.978 2.813 2.813 0 0 1 3.98-3.978m3.717 10.634A7.848 7.848 0 0 0 12 16.5a7.845 7.845 0 0 0-5.707 2.459"/></svg>
          {{ t('navigation.cabinet') }}
        </a>
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useTranslation } from 'i18next-vue';
  import { NavigationLib } from '@shared/lib';
  import { injectAppContext } from '@shared/app-context';
  import LanguageSwitch from './LanguageSwitch.desktop.vue';

  const { locale } = injectAppContext();
  const { t } = useTranslation();

  type MenuItem = {
    title: string;
    href: string;
    disabled?: boolean;
    classList?: string;
  };

  const menuItems = computed<Array<MenuItem>>(() => [
    {
      title: t('navigation.avia'),
      href: NavigationLib.toAvia(locale),
    },
    {
      title: t('navigation.rws'),
      href: NavigationLib.toRailways(locale),
    },
    {
      title: t('navigation.hotels'),
      href: NavigationLib.toHotels(locale),
    },
    {
      title: t('navigation.tours'),
      href: NavigationLib.mainPage({ locale, isWebview: false }), // Component is desktop only
      classList: 'text-green-600',
    },
    {
      title: t('navigation.b2b'),
      href: NavigationLib.toB2bLading(locale),
    },
    {
      title: t('navigation.bonuses'),
      href: NavigationLib.toBonusesLanding(locale),
      classList: 'px-4 text-white rounded-xl loyalty-bg',
    },
    {
      title: t('navigation.blog'),
      href: NavigationLib.toBlog(locale, {
        medium: 'header-desktop',
        campaign: 'header-menu',
      }),
    },
  ]);
</script>

<style>
  .loyalty-bg {
    @apply bg-gradient-to-r from-loyalty-1 to-loyalty-2 duration-300 ease-in;
    transition-property: background;
    background-size: 150%;

    &:hover {
      background-position-x: 75%;
    }

    &:active {
      background-position-x: 100%;
    }
  }
</style>
